import { ExportSearchGrouping } from '@aibees/elephant/hooks';
import { ElephantPresetType } from '@aibees/elephant/types';
import { LabelGrouping } from '@aibees/elephant/types/label';
import { HeaderMenuTitle } from '../../types';
import * as SX from './sx';
import { SearchListCardTypeFilterOption } from './types';

export const SAVED_GROUPING_OPTION: SearchListCardTypeFilterOption[] = [
  {
    key: `${ElephantPresetType.COMPANY_SAVED_SEARCH},${ElephantPresetType.PEOPLE_SAVED_SEARCH}`,
    value: 'All Types',
  },
  {
    key: ElephantPresetType.COMPANY_SAVED_SEARCH,
    value: 'Company',
    icon: 'business',
    iconSx: SX.companyIcon,
  },
  {
    key: ElephantPresetType.PEOPLE_SAVED_SEARCH,
    value: 'People',
    icon: 'people-outline',
    iconSx: SX.contactIcon,
  },
];

export const LABELS_GROUPING_OPTION: SearchListCardTypeFilterOption[] = [
  {
    key: `${LabelGrouping.COMPANY},${LabelGrouping.PEOPLE}`,
    value: 'All Types',
  },
  {
    key: LabelGrouping.COMPANY,
    value: 'Company',
    icon: 'business',
    iconSx: SX.companyIcon,
  },
  {
    key: LabelGrouping.PEOPLE,
    value: 'People',
    icon: 'people-outline',
    iconSx: SX.contactIcon,
  },
];

export const LIST_GROUPING_OPTION: SearchListCardTypeFilterOption[] = [
  {
    key: `${LabelGrouping.COMPANY},${LabelGrouping.PEOPLE}`,
    value: 'All Types',
  },
  {
    key: LabelGrouping.COMPANY,
    value: 'Company',
    icon: 'business',
    iconSx: SX.companyIcon,
  },
  {
    key: LabelGrouping.PEOPLE,
    value: 'People',
    icon: 'people-outline',
    iconSx: SX.contactIcon,
  },
];

export const EXPORT_GROUPING_OPTION: SearchListCardTypeFilterOption[] = [
  {
    key: `${ExportSearchGrouping.COMPANY},${ExportSearchGrouping.PERSON}`,
    value: 'All Types',
  },
  {
    key: ExportSearchGrouping.COMPANY,
    value: 'Company',
    icon: 'business',
    iconSx: SX.companyIcon,
  },
  {
    key: ExportSearchGrouping.PERSON,
    value: 'People',
    icon: 'people-outline',
    iconSx: SX.contactIcon,
  },
];

export const listGrouping: {
  [key in HeaderMenuTitle]: SearchListCardTypeFilterOption[];
} = {
  Saved: SAVED_GROUPING_OPTION,
  Labels: LABELS_GROUPING_OPTION,
  Lists: LIST_GROUPING_OPTION,
  Export: EXPORT_GROUPING_OPTION,
  Enrich: EXPORT_GROUPING_OPTION,
};
